import React, { useEffect, useState } from 'react';
import Styles from '../activities-styles.scss';
import ButtonKVBase from '@/presentation/components/button-kv/button-kv';
import ButtonBorderedKVBaseAdmin from '@/presentation/components/button-bordered-kv-admin/button-bordered-kv-admin';
import ButtonBack from '@/presentation/components/button-back/button-back';
import Mascot from '@/presentation/components/mascot-render/mascot';
const SuccessActivity = ({ menuItemsState, onBackModule, onStartActivity }) => {
    const index = menuItemsState === null || menuItemsState === void 0 ? void 0 : menuItemsState.findIndex(item => (item === null || item === void 0 ? void 0 : item.status) === 'current');
    const [lastItem, setLastItem] = useState(false);
    useEffect(() => {
        const find = menuItemsState.some(data => data.completed !== true);
        setLastItem(index === menuItemsState.length - 1 && !find);
    }, [menuItemsState]);
    return (React.createElement(React.Fragment, null,
        React.createElement("hr", { style: { width: '100%' } }),
        React.createElement("div", { style: { display: 'flex', gap: '20px', alignContent: 'center' } },
            React.createElement("div", { style: { display: 'flex', gap: '10px', alignContent: 'center' } },
                React.createElement("img", { src: `https://app.dev.kidvestors.co/assets/activities/needs-wants/phone.png`, style: { objectFit: 'contain', width: 150 } })),
            React.createElement("div", { style: { display: 'flex', gap: '10px', alignItems: 'center', flexDirection: 'column', justifyContent: 'center' } },
                React.createElement("span", { className: Styles.congratulations, style: { fontWeight: 'bold', fontSize: '24px' } }, "Congratulations!"),
                React.createElement("span", null, "You have successfully completed this activity."),
                React.createElement(ButtonBorderedKVBaseAdmin, { type: "button", className: Styles.backButton, onClick: onStartActivity }, "Play Again")),
            React.createElement(Mascot, { width: "200px" })),
        React.createElement("hr", { style: { width: '100%' } }),
        React.createElement("div", { className: Styles.buttons, style: { marginTop: '16px' } },
            React.createElement("div", { className: Styles.left },
                React.createElement(ButtonBack, { btnBackgroundGradient: "white", onClick: () => {
                        if (menuItemsState) {
                            const previous = menuItemsState === null || menuItemsState === void 0 ? void 0 : menuItemsState.findIndex(item => (item === null || item === void 0 ? void 0 : item.status) === 'current');
                            if (previous > 0) {
                                menuItemsState[previous - 1].onClick();
                            }
                        }
                    }, text: "Previous" })),
            React.createElement("div", { className: Styles.right },
                React.createElement("div", { className: Styles.buttonNext },
                    React.createElement(ButtonKVBase, { type: "button", btnBackgroundGradient: !lastItem
                            ? 'linear-gradient(90deg, #FFA800 0%, #7F1BFF 100%)'
                            : 'linear-gradient(90deg, #00A3FF 0%, #7000FF 100%)', disabled: false, onClick: () => {
                            if (lastItem) {
                                onBackModule();
                            }
                            else if (menuItemsState) {
                                const next = menuItemsState === null || menuItemsState === void 0 ? void 0 : menuItemsState.findIndex(item => (item === null || item === void 0 ? void 0 : item.status) === 'current');
                                if (next < menuItemsState.length - 1) {
                                    menuItemsState[next + 1].onClick();
                                }
                            }
                        } }, lastItem ? 'Start New Lesson' : 'Next Activity'))))));
};
export default SuccessActivity;
